// packages/i18n/src/shared/utils/urlCodeOfPathname.ts
import type { UrlMap } from '@tourtask/types/navigation';

import { getLocaleFromPathname } from './getLocaleFromPathname';
import { matchUrlPatterns } from './matchUrlPatterns';

/**
 * The code of the page a concrete pathname opens: its locale's map (from the path's first
 * segment, else the default locale) and the best pattern match there, a page's own literal
 * path before a parametric sibling (`matchUrlPatterns`). Pure and isomorphic: the client
 * I18nContext binds it to its urlMap prop, and the backoffice server matches with it too.
 *
 * `null` for a path no page matches. That is a normal runtime condition (a legacy bookmark, a
 * trailing slash, a route the map does not cover), so callers fall back instead of throwing.
 */
export function urlCodeOfPathname(urlMap: UrlMap, pathname: string): string | null {
  const localeMap = urlMap[getLocaleFromPathname(pathname)];
  if (!localeMap) return null;
  return matchUrlPatterns(localeMap, pathname)[0]?.code ?? null;
}
